module.exports = __webpack_public_path__ + "img/trivia-838.5f07521e.jpeg";